import React from "react";
import { COLORS } from "@app/constants";
import { Text, View } from "@/styles/reactnative";
import { useWindowDimensions } from "@app/hooks";

const WorldRankingTableHeader = ({ data }: any) => {
  const { width } = useWindowDimensions();
  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        borderTop: `1px solid ${COLORS.lightGray2}`,
      }}
    >
      {data.map((item: any, index: any) => (
        <Text
          size={width < 900 ? 12 : 14}
          key={index.toString()}
          style={{
            background: "transparent",
            height: 34,
            paddingBlock: 10,
            color: COLORS.lightGray,
            width: index === 0 ? "5%" : index === 1 ? "20%" : "13%",
            cursor: "pointer",
            justifyContent: "flex-start",
            paddingLeft: 5,
          }}
        >
          {item}
        </Text>
      ))}
    </View>
  );
};

export default React.memo(WorldRankingTableHeader);
